export default __webpack_public_path__ + "static/media/geodatin-map-logo.a4b69717.png";